<script setup lang="ts">
import { type Component, inject, onUnmounted } from 'vue';
import { type BreadcrumbItemProps, registerBreadcrumbItemKey } from './internal';

const props = defineProps<BreadcrumbItemProps>();
const slots = defineSlots<{ default: Component }>();

const registerBreadcrumbItem = inject(registerBreadcrumbItemKey)!;
const unregisterBreadcrumbItem = registerBreadcrumbItem(props, slots.default);

onUnmounted(() => unregisterBreadcrumbItem());
</script>

<!-- eslint-disable-next-line vue/valid-template-root -->
<template>
  <!-- renderless component -->
</template>
